// removed by extract-text-webpack-plugin
module.exports = {"chip":"chip__3ftCY","chiplink":"chiplink__2GH9D"};


//////////////////
// WEBPACK FOOTER
// ./components/LinkChip/style.css
// module id = hDgN
// module chunks = 9